import httpClientNotifications from '../api/httpClientNotifications';

export const getEmailTemplates = async ({ pageNumber = 1, pageSize = 10, isActive, isSystemTemplate, search } = {}) => {
  const response = await httpClientNotifications.get('/api/notifications/EmailTemplate/GetAll', {
    params: { pageNumber, pageSize, isActive, isSystemTemplate, search },
  });
  return response.data;
};

export const searchEmailTemplates = async ({ keyword } = {}) => {
  const response = await httpClientNotifications.get('/api/notifications/EmailTemplate/Search', {
    params: { keyword },
  });
  return response.data;
};

export const getEmailTemplateById = async (id) => {
  const response = await httpClientNotifications.get(`/api/notifications/EmailTemplate/GetById/${id}`);
  return response.data;
};

export const createEmailTemplate = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/EmailTemplate/Create', payload);
  return response.data;
};

export const updateEmailTemplate = async (payload) => {
  const response = await httpClientNotifications.put('/api/notifications/EmailTemplate/Update', payload);
  return response.data;
};

export const deleteEmailTemplate = async (id) => {
  const response = await httpClientNotifications.delete(`/api/notifications/EmailTemplate/Delete/${id}`);
  return response.data;
};

export default {
  getEmailTemplates,
  searchEmailTemplates,
  getEmailTemplateById,
  createEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
};


